module.exports = __webpack_public_path__ + "static/media/remove-ic@1x.80836a83.svg";